export function matchesRule(value: string, rule: string | RegExp): boolean {
  if (typeof rule === "string") return value.includes(rule);
  return rule.test(value);
}

export function shouldHandleAnchor(a: HTMLAnchorElement): boolean {
  const href = (a.getAttribute("href") || "").trim();
  if (!href) return false;
  if (href.startsWith("#")) return false;
  if (href.startsWith("mailto:") || href.startsWith("tel:")) return false;
  if (href.startsWith("javascript:")) return false;
  if (a.hasAttribute("download")) return false;

  const target = (a.getAttribute("target") || "").toLowerCase();
  if (target === "_blank") return false;

  return true;
}

export function shouldAllowUrl(opts: {
  url: URL;
  origin: string;
  allowSameOriginOnly: boolean;
  allow: Array<string | RegExp>;
  deny: Array<string | RegExp>;
}): boolean {
  const { url, origin, allowSameOriginOnly, allow, deny } = opts;

  if (allowSameOriginOnly && url.origin !== origin) return false;

  const full = url.toString();
  const path = url.pathname + url.search;

  for (const r of deny) {
    if (matchesRule(full, r) || matchesRule(path, r)) return false;
  }

  if (allow.length > 0) {
    for (const r of allow) {
      if (matchesRule(full, r) || matchesRule(path, r)) return true;
    }
    return false;
  }

  return true;
}
